import { ExternalProvider } from "../enums/external-provider.enum";

export type VoiceIDMapping = { [key: string]: string };

// Source: https://cloud.google.com/text-to-speech/docs/voices
export const googleVoiceIds: VoiceIDMapping = {
  'fallback': "en-US-Wavenet-F",
  "ar-XA-m": "ar-XA-Wavenet-A",
  "ar-XA-f": "ar-XA-Wavenet-B",
  "bn-IN-m": "bn-IN-Standard-B",
  "bn-IN-f": "bn-IN-Standard-A",
  "yue-HK-m": "yue-HK-Standard-B",
  "yue-HK-f": "yue-HK-Standard-A",
  "cs-CZ": "cs-CZ-Wavenet-B",
  "da-DKI-m": "da-DK-Wavenet-G",
  "da-DK-f": "da-DK-Wavenet-F",
  "nl-NL-m": "nl-NL-Wavenet-G",
  "nl-NL-f": "nl-NL-Wavenet-F",
  "en-AU-m": "en-AU-Wavenet-B",
  "en-AU-f": "en-AU-Wavenet-C",
  "en-IN-m": "en-IN-Wavenet-B",
  "en-IN-f": "en-IN-Wavenet-A",
  "en-GB-m": "en-GB-Wavenet-O",
  "en-GB-f": "en-GB-Wavenet-N",
  "en-US-m": "en-US-Wavenet-B",
  "en-US-f": "en-US-Wavenet-E",
  "fil-PH-m": "fil-PH-Wavenet-C",
  "fil-PH-f": "fil-PH-Wavenet-A",
  "fi-FI": "fi-FI-Wavenet-B",
  "fr-CA-m": "fr-CA-Wavenet-C",
  "fr-CA-f": "fr-CA-Wavenet-B",
  "fr-FR-m": "fr-FR-Wavenet-G",
  "fr-FR-f": "fr-FR-Wavenet-F",
  "de-DE-m": "de-DE-Wavenet-H",
  "de-DE-f": "de-DE-Wavenet-G",
  "el-GR": "el-GR-Wavenet-B",
  "gu-IN-m": "gu-IN-Standard-B",
  "gu-IN-f": "gu-IN-Standard-A",
  "hi-IN-m": "hi-IN-Wavenet-B",
  "hi-IN-f": "hi-IN-Wavenet-D",
  "hu-HU": "hu-HU-Wavenet-B",
  "id-ID-m": "id-ID-Wavenet-B",
  "id-ID-f": "id-ID-Wavenet-A",
  "it-IT-m": "it-IT-Wavenet-F",
  "it-IT-f": "it-IT-Wavenet-E",
  "ja-JP-m": "ja-JP-Wavenet-D",
  "ja-JP-f": "ja-JP-Wavenet-B",
  "kn-IN-m": "kn-IN-Standard-b",
  "kn-IN-f": "kn-IN-Standard-A",
  "ko-KR-m": "ko-KR-Wavenet-C",
  "ko-KR-f": "ko-KR-Wavenet-A",
  "ml-IN-m": "ml-IN-Standard-B",
  "ml-IN-f": "ml-IN-Standard-A",
  "cmn-CN-m": "cmn-CN-Wavenet-B",
  "cmn-CN-f": "cmn-CN-Wavenet-A",
  "cmn-TW-m": "cmn-TW-Wavenet-B",
  "cmn-TW-f": "cmn-TW-Wavenet-A",
  "nb-NO-m": "nb-NO-Wavenet-G",
  "nb-NO-f": "nb-NO-Wavenet-F",
  "pl-PL-m": "pl-PL-Wavenet-G",
  "pl-PL-f": "pl-PL-Wavenet-F",
  "pt-BR": "pt-BR-Wavenet-A",
  "pt-PT-m": "pt-PT-Wavenet-F",
  "pt-PT-f": "pt-PT-Wavenet-E",
  "ru-RU-m": "ru-RU-Wavenet-B",
  "ru-RU-f": "ru-RU-Wavenet-A",
  "sk-SK": "sk-SK-Wavenet-B",
  "ta-IN-m": "ta-IN-Standard-B",
  "ta-IN-f": "ta-IN-Standard-A",
  "sv-SE": "sv-SE-Wavenet-F",
  "tr-TR-m": "tr-TR-Wavenet-B",
  "tr-TR-f": "tr-TR-Wavenet-A",
  "uk-UA": "uk-UA-Wavenet-A",
  "vi-VN-m": "vi-VN-Wavenet-B",
  "vi-VN-f": "vi-VN-Wavenet-C",
};

// Source: https://learn.microsoft.com/en-us/azure/ai-services/speech-service/language-support?tabs=tts#text-to-speech
export const microsoftVoiceIds: VoiceIDMapping = {
  'fallback': "en-US-AriaNeural",
  "af-ZA-f": "af-ZA-AdriNeural",
  "af-ZA-m": "af-ZA-WillemNeural",
  "am-ET-f": "am-ET-MekdesNeural",
  "am-ET-m": "am-ET-AmehaNeural",
  "ar-XA-f": "ar-AE-FatimaNeural",
  "ar-XA-m": "ar-AE-HamdanNeural",
  "ar-AE-f": "ar-AE-FatimaNeural",
  "ar-AE-m": "ar-AE-HamdanNeural",
  "ar-BH-f": "ar-BH-LailaNeural",
  "ar-BH-m": "ar-BH-AliNeural",
  "ar-DZ-f": "ar-DZ-AminaNeural",
  "ar-DZ-m": "ar-DZ-IsmaelNeural",
  "ar-EG-f": "ar-EG-SalmaNeural",
  "ar-EG-m": "ar-EG-ShakirNeural",
  "ar-IQ-f": "ar-IQ-RanaNeural",
  "ar-IQ-m": "ar-IQ-BasselNeural",
  "ar-JO-f": "ar-JO-SanaNeural",
  "ar-JO-m": "ar-JO-TaimNeural",
  "ar-KW-f": "ar-KW-NouraNeural",
  "ar-KW-m": "ar-KW-FahedNeural",
  "ar-LB-f": "ar-LB-LaylaNeural",
  "ar-LB-m": "ar-LB-RamiNeural",
  "ar-LY-f": "ar-LY-ImanNeural",
  "ar-LY-m": "ar-LY-OmarNeural",
  "ar-MA-f": "ar-MA-MounaNeural",
  "ar-MA-m": "ar-MA-JamalNeural",
  "ar-OM-f": "ar-OM-AyshaNeural",
  "ar-OM-m": "ar-OM-AbdullahNeural",
  "ar-QA-f": "ar-QA-AmalNeural",
  "ar-QA-m": "ar-QA-MoazNeural",
  "ar-SA-f": "ar-SA-ZariyahNeural",
  "ar-SA-m": "ar-SA-HamedNeural",
  "ar-SY-f": "ar-SY-AmanyNeural",
  "ar-SY-m": "ar-SY-LaithNeural",
  "ar-TN-f": "ar-TN-ReemNeural",
  "ar-TN-m": "ar-TN-HediNeural",
  "ar-YE-f": "ar-YE-MaryamNeural",
  "ar-YE-m": "ar-YE-SalehNeural",
  "ar-EG": "ar-EG-SalmaNeural",
  "ar-SA": "ar-SA-ZariyahNeural",
  "bg-BG": "bg-BG-BorislavNeural",
  "ca-ES": "ca-ES-AlbaNeural",
  "cs-CZ": "cs-CZ-AntoninNeural",
  "da-DK": "da-DK-ChristelNeural",
  "de-AT": "de-AT-JonasNeural",
  "de-CH": "de-CH-JanNeural",
  "de-DE-m": "de-DE-ConradNeural",
  "de-DE-f": "de-DE-KatjaNeural",
  "el-GR": "el-GR-NestorasNeural",
  "en-AU": "en-AU-NatashaNeural",
  "en-CA": "en-CA-ClaraNeural",
  "en-GB-m": "en-GB-ElliotNeural",
  "en-GB-f": "en-GB-HollieNeural",
  "en-IE": "en-IE-ConnorNeural",
  "en-IN-m": "en-IN-AaravNeural",
  "en-IN-f": "en-IN-NeerjaNeural",
  "en-US-m": "en-US-GuyNeural",
  "en-US-f": "en-US-AriaNeural",
  "es-ES-m": "es-ES-AlvaroNeural",
  "es-ES-f": "es-ES-ElviraNeural",
  "es-MX-m": "es-MX-JorgeNeural",
  "es-MX-f": "es-MX-DaliaNeural",
  "fi-FI": "fi-FI-NooraNeural",
  "fr-CA": "fr-CA-SylvieNeural",
  "fr-CH": "fr-CH-ArianeNeural",
  "fr-FR-m": "fr-FR-HenriNeural",
  "fr-FR-f": "fr-FR-DeniseNeural",
  "he-IL": "he-IL-AvriNeural",
  "hi-IN-m": "hi-IN-AaravNeural",
  "hi-IN-f": "hi-IN-AnanyaNeural",
  "hr-HR": "hr-HR-SreckoNeural",
  "hu-HU": "hu-HU-TamasNeural",
  "id-ID": "id-ID-ArdiNeural",
  "it-IT-m": "it-IT-DiegoNeural",
  "it-IT-f": "it-IT-ElsaNeural",
  "ja-JP-m": "ja-JP-KeitaNeural",
  "ja-JP-f": "ja-JP-NanamiNeural",
  "ko-KR": "ko-KR-SunHiNeural",
  "ms-MY": "ms-MY-OsmanNeural",
  "nb-NO": "nb-NO-IselinNeural",
  "nl-NL": "nl-NL-ColetteNeural",
  "pl-PL": "pl-PL-ZofiaNeural",
  "pt-BR-m": "pt-BR-AntonioNeural",
  "pt-BR-f": "pt-BR-FranciscaNeural",
  "pt-PT": "pt-PT-FernandaNeural",
  "ro-RO": "ro-RO-EmilNeural",
  "ru-RU-m": "ru-RU-DmitryNeural",
  "ru-RU-f": "ru-RU-DariyaNeural",
  "sk-SK": "sk-SK-LukasNeural",
  "sl-SI": "sl-SI-RokNeural",
  "sv-SE": "sv-SE-HilleviNeural",
  "ta-IN": "ta-IN-ValluvarNeural",
  "te-IN": "te-IN-MohanNeural",
  "th-TH": "th-TH-AcharaNeural",
  "tr-TR": "tr-TR-EmelNeural",
  "vi-VN": "vi-VN-NamMinhNeural",
  "zh-CN-m": "zh-CN-YunyangNeural",
  "zh-CN-f": "zh-CN-XiaoxiaoNeural",
  "zh-HK": "zh-HK-HiuGaaiNeural",
  "zh-TW-m": "zh-TW-YunJheNeural",
  "zh-TW-f": "zh-TW-HsiaoYuNeural",
};

// Source: https://docs.aws.amazon.com/polly/latest/dg/available-voices.html
export const amazonVoiceIds: VoiceIDMapping = {
  'fallback': "Joanna",
  arb: "Zeina",
  "ar-XA-m": "Zayd",
  "ar-XA-f": "Hala",
  "ar-AE-m": "Zayd",
  "ar-AE-f": "Hala",
  "cmn-CN": "Zhiyu",
  "da-DK-m": "Mads",
  "da-DK-f": "Naja",
  "nl-NL-m": "Ruben",
  "nl-NL-f": "Lotte",
  "en-AU-m": "Russell",
  "en-AU-f": "Nicole",
  "en-GB-m": "Brian",
  "en-GB-f": "Amy",
  "en-IN": "Raveena",
  "en-US-m": "Joey",
  "en-US-f": "Joanna",
  "en-GB-WLS": "Geraint",
  "fr-CA": "Chantal",
  "fr-FR-m": "Mathieu",
  "fr-FR-f": "Léa",
  "de-DE-m": "Hans",
  "de-DE-f": "Vicki",
  "hi-IN": "Aditi",
  "is-IS-m": "Karl",
  "is-IS-f": "Dóra/Dora",
  "it-IT-m": "Giorgio",
  "it-IT-f": "Carla",
  "ja-JP-m": "Takumi",
  "ja-JP-f": "Mizuki",
  "ko-KR": "Seoyeon",
  "nb-NO": "Liv",
  "pl-PL-m": "Jacek",
  "pl-PL-f": "Ewa",
  "pt-BR-m": "Ricardo",
  "pt-BR-f": "Camila",
  "pt-PT-m": "Cristiano",
  "pt-PT-f": "Inês/Ines",
  "ro-RO": "Carmen",
  "ru-RU-m": "Maxim",
  "ru-RU-f": "Tatyana",
  "es-ES-m": "Enrique",
  "es-ES-f": "Conchita",
  "es-MX": "Mia",
  "es-US-m": "Miguel",
  "es-US-f": "Lupe",
  "sv-SE": "Astrid",
  "tr-TR": "Filiz",
  "cy-GB": "Gwyneth",
};

// Source https://cloud.ibm.com/docs/text-to-speech?topic=text-to-speech-voices
// Source (somehow more complete) https://github.com/Pen-y-Fan/watson-text-to-speech-php
export const ibmVoiceIds: VoiceIDMapping = {
  'fallback': "en-US_AllisonV3Voice",
  arb: "ar-AR_OmarVoice",
  "ar-XA": "ar-AR_OmarVoice",
  "ar-AR": "ar-AR_OmarVoice",
  "pt-BR": "pt-BR_IsabelaV3Voice",
  "zh-CN-m": "zh-CN_WangWeiVoice",
  "zh-CN-f": "zh-CN_LiNaVoice",
  "nl-NL-m": "nl-NL_LiamVoice",
  "nl-NL-f": "nl-NL_MerelV3Voice",
  "en-GB-m": "en-GB_JamesV3Voice",
  "en-GB-f": "en-GB_CharlotteV3Voice",
  "en-US-m": "en-US_KevinV3Voice",
  "en-US-f": "en-US_AllisonV3Voice",
  "fr-FR-m": "fr-FR_NicolasV3Voice",
  "fr-FR-f": "fr-FR_ReneeV3Voice",
  "de-DE-m": "de-DE_DieterV3Voice",
  "de-DE-f": "de-DE_BirgitV3Voice",
  "it-IT": "it-IT_FrancescaV3Voice",
  "ja-JP": "ja-JP_EmiV3Voice",
  "ko-KR": "ko-KR_YoungmiVoice",
  "es-ES-m": "es-ES_EnriqueV3Voice",
  "es-ES-f": "es-ES_LauraV3Voice",
  "es-LA": "es-LA_SofiaV3Voice",
  "es-US": "es-US_SofiaV3Voice",
};

const specialCases: { [key: string]: string } = {
  ar: "ar-XA",
  ba: "ba-RU",
  bg: "bg-BG",
  ca: "ca-ES",
  cmn: "cmn-CN",
  cs: "cs-CZ",
  cy: "cy-GB",
  da: "da-DK",
  de: "de-DE",
  el: "el-GR",
  en: "en-GB",
  es: "es-ES",
  et: "et-EE",
  eu: "eu-ES",
  fi: "fi-FI",
  fil: "fil-PH",
  fr: "fr-FR",
  he: "he-IL",
  hi: "hi-IN",
  hr: "hr-HR",
  hu: "hu-HU",
  id: "id-ID",
  is: "is-IS",
  it: "it-IT",
  ja: "ja-JP",
  ko: "ko-KR",
  lt: "lt-LT",
  lv: "lv-LV",
  ms: "ms-MY",
  nb: "nb-NO",
  nl: "nl-NL",
  no: "nb-NO",
  pl: "pl-PL",
  pt: "pt-BR",
  ro: "ro-RO",
  ru: "ru-RU",
  sk: "sk-SK",
  sl: "sl-SI",
  sv: "sv-SE",
  ta: "ta-IN",
  te: "te-IN",
  th: "th-TH",
  tr: "tr-TR",
  uk: "uk-UA",
  vi: "vi-VN",
  yue: "yue-HK",
  zh: "zh-CN",
};

const languageVariantGroups: string[][] = [
  ["en", "eng"],
  ["ar", "arb"],
  ["es", "spa"],
  ["de", "deu"],
  ["fr", "fra"],
  ["it", "ita"],
  ["pt", "por"],
];

function findWithLanguageVariants(
  language: string,
  map: { [key: string]: any }
): any {
  if (!map || typeof map !== "object") return undefined;

  const lowerLang = language.toLowerCase();
  const group = languageVariantGroups.find((group) =>
    group.includes(lowerLang)
  ) ?? [lowerLang];

  for (const variant of group) {
    if (variant in map) {
      return map[variant];
    }
  }

  return undefined;
}

export function getLanguageConfig(
  language: string,
  preferredDialects: { [key: string]: string },
  preferredVoiceType: string,
  provider: ExternalProvider
): { languageCode: string; voiceId: string } {
  const preferredDialect = findWithLanguageVariants(
    language,
    preferredDialects
  );
  const preferredDialectAndVoice =
    preferredDialect && `${preferredDialect}-${preferredVoiceType}`;
  const defaultDialect =
    findWithLanguageVariants(language, specialCases) ||
    language + "-" + language?.toUpperCase();
  const defaultDialectAndVoice = `${defaultDialect}-${preferredVoiceType}`;

  const providerVoiceIds = getProviderVoiceIds(provider);

  return {
    languageCode: preferredDialect || defaultDialect,
    voiceId:
      providerVoiceIds[preferredDialectAndVoice] ||
      providerVoiceIds[preferredDialect] ||
      providerVoiceIds[defaultDialectAndVoice] ||
      providerVoiceIds[defaultDialect] ||
      providerVoiceIds['fallback'] ||
      providerVoiceIds['en-US-f'] ||
      providerVoiceIds['en-US-m'] ||
      providerVoiceIds['en-us-m'] ||
      providerVoiceIds['en-US'] ||
      Object.values(providerVoiceIds)[0] || // Fallback to the first available voice
      ''
  };
}

export function getProviderVoiceIds(provider: ExternalProvider) {
  switch (provider) {
    case ExternalProvider.Microsoft:
      return microsoftVoiceIds;
    case ExternalProvider.IBM:
      return ibmVoiceIds;
    case ExternalProvider.Google:
      return googleVoiceIds;
    case ExternalProvider.Amazon:
      return amazonVoiceIds;
    default:
      return {};
  }
}

export const languageRegionNames: Record<string, string> = {
  "ar-AR": "Arabic (Saudi Arabia)",
  "ar-XA": "Arabic (Saudi Arabia)",
  "af-ZA": "Afrikaans (South Africa)",
  "am-ET": "Amharic (Ethiopia)",
  "ar-AE": "Arabic (United Arab Emirates)",
  "ar-BH": "Arabic (Bahrain)",
  "ar-DZ": "Arabic (Algeria)",
  "ar-EG": "Arabic (Egypt)",
  "ar-IQ": "Arabic (Iraq)",
  "ar-JO": "Arabic (Jordan)",
  "ar-KW": "Arabic (Kuwait)",
  "ar-LB": "Arabic (Lebanon)",
  "ar-LY": "Arabic (Libya)",
  "ar-MA": "Arabic (Morocco)",
  "ar-OM": "Arabic (Oman)",
  "ar-QA": "Arabic (Qatar)",
  "ar-SA": "Arabic (Saudi Arabia)",
  "ar-SY": "Arabic (Syria)",
  "ar-TN": "Arabic (Tunisia)",
  "ar-YE": "Arabic (Yemen)",
  "bg-BG": "Bulgarian (Bulgaria)",
  "ca-ES": "Catalan (Spain)",
  "cs-CZ": "Czech (Czech Republic)",
  "cmn-CN": "Chinese (Mainland China)",
  "cmn-TW": "Chinese (Taiwan)",
  "da-DK": "Danish (Denmark)",
  "da-DKI": "Danish (Denmark)",
  "de-AT": "German (Austria)",
  "de-CH": "German (Switzerland)",
  "de-DE": "German (Germany)",
  "el-GR": "Greek (Greece)",
  "en-AU": "English (Australia)",
  "en-CA": "English (Canada)",
  "en-GB": "English (United Kingdom)",
  "en-IE": "English (Ireland)",
  "en-IN": "English (India)",
  "en-US": "English (United States)",
  "es-ES": "Spanish (Spain)",
  "es-MX": "Spanish (Mexico)",
  "fi-FI": "Finnish (Finland)",
  "fr-CA": "French (Canada)",
  "fr-CH": "French (Switzerland)",
  "fr-FR": "French (France)",
  "he-IL": "Hebrew (Israel)",
  "hi-IN": "Hindi (India)",
  "hr-HR": "Croatian (Croatia)",
  "hu-HU": "Hungarian (Hungary)",
  "id-ID": "Indonesian (Indonesia)",
  "it-IT": "Italian (Italy)",
  "ja-JP": "Japanese (Japan)",
  "ko-KR": "Korean (South Korea)",
  "ms-MY": "Malay (Malaysia)",
  "nb-NO": "Norwegian Bokmål (Norway)",
  "nl-NL": "Dutch (Netherlands)",
  "pl-PL": "Polish (Poland)",
  "pt-BR": "Portuguese (Brazil)",
  "pt-PT": "Portuguese (Portugal)",
  "ro-RO": "Romanian (Romania)",
  "ru-RU": "Russian (Russia)",
  "sk-SK": "Slovak (Slovakia)",
  "sl-SI": "Slovenian (Slovenia)",
  "sv-SE": "Swedish (Sweden)",
  "ta-IN": "Tamil (India)",
  "te-IN": "Telugu (India)",
  "th-TH": "Thai (Thailand)",
  "tr-TR": "Turkish (Turkey)",
  "vi-VN": "Vietnamese (Vietnam)",
  "zh-CN": "Chinese (Mainland China)",
  "zh-HK": "Chinese (Hong Kong)",
  "zh-TW": "Chinese (Taiwan)",
};

export const isoLanguageNames: Record<string, string> = {
  af: "Afrikaans",
  am: "Amharic",
  ar: "Arabic",
  arb: "Arabic (2)",
  bg: "Bulgarian",
  ca: "Catalan",
  cmn: "Chinese (Mandarin)",
  cs: "Czech",
  da: "Danish",
  de: "German",
  el: "Greek",
  en: "English",
  es: "Spanish",
  fi: "Finnish",
  fr: "French",
  he: "Hebrew",
  hi: "Hindi",
  hr: "Croatian",
  hu: "Hungarian",
  id: "Indonesian",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  ms: "Malay",
  nb: "Norwegian Bokmål",
  nl: "Dutch",
  pl: "Polish",
  pt: "Portuguese",
  ro: "Romanian",
  ru: "Russian",
  sk: "Slovak",
  sl: "Slovenian",
  sv: "Swedish",
  ta: "Tamil",
  te: "Telugu",
  th: "Thai",
  tr: "Turkish",
  vi: "Vietnamese",
  zh: "Chinese",
};
